<ion-row class="iti-row">
    <ion-col size="2" class="iti-col">
        <p class="iti-dates ">
            {{ chainItem?.startdate | date: 'longDate':'UTC' }} -
            {{ chainItem?.enddate | date: 'longDate':'UTC' }}
        </p>
    </ion-col>

    <ion-col size="2" class="iti-col iti-relative">
        <div class="iti-lead" [ngClass]="{ 'even-background': !(index % 2) }">
            <fa-icon [icon]="iconOfiti"></fa-icon>
        </div>
        <div class="iti-border">
            <p>
                {{ chainItem?.name }}
            </p>
        </div>
    </ion-col>

    <ion-col size="1" class="iti-col ion-text-center">
        <p class="dark-teal">
            {{ chainItem?.type }}
        </p>
    </ion-col>

    <ion-col size="2" class="iti-col">
        <p class="dark-teal ion-text-center">
            <span><fa-icon [icon]="faMapMarkerAlt"></fa-icon></span
            >{{ chainItem?.city }}, {{ chainItem?.state }}
        </p>
    </ion-col>

    <ion-col size="1" class="iti-col">
        <p class="ion-text-center">${{ chainItem?.price }} USD</p>
    </ion-col>

    <ion-col size="1" class="iti-col">
        <ion-button
            (click)="applicationRouting(chainItem)"
            color="primary"
            *ngIf="chainItem?.states === 'Accepted'"
            class="ion-text-center iti-button"
            size="small"
            fill="outline"
        >
            <ion-icon slot="start" name="cart"></ion-icon>
            {{ chainItem | futureStatus }}
            <ion-icon slot="end" name="arrow-forward"></ion-icon>
        </ion-button>
        <ion-button
            (click)="applicationRouting(chainItem)"
            color="secondary"
            *ngIf="chainItem?.states === 'Reserved'"
            class="ion-text-center iti-button"
            size="small"
            fill="outline"
        >
            {{ chainItem | futureStatus }}
            <ion-icon slot="end" name="arrow-forward"></ion-icon>
        </ion-button>
        <ion-button
            color="secondary"
            (click)="applicationRouting(chainItem)"
            *ngIf="chainItem?.states === 'Pending'"
            class="ion-text-center iti-button"
            size="small"
            fill="outline"
        >
            <ion-icon slot="start" name="time-outline"></ion-icon>
            {{ chainItem | futureStatus }}
        </ion-button>
    </ion-col>
    <ion-col
        *ngIf="
            chainItem?.states === 'Pending' || chainItem?.states === 'Accepted'
        "
        size="1"
        class="iti-last-col ion-text-right"
    >
        <ion-button
            (click)="cancelApplication(chainItem)"
            fill="clear"
            *ngIf="
                chainItem?.states === 'Pending' ||
                chainItem?.states === 'Accepted'
            "
            shape="round"
            class="iti-remove"
        >
            Cancel
        </ion-button>
    </ion-col>
</ion-row>
